import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {FuseMediaWatcherService} from '@fuse/services/media-watcher';
import {FuseNavigationService, FuseVerticalNavigationComponent} from '@fuse/components/navigation';
import {Navigation} from 'app/core/navigation/navigation.types';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {UserService} from "app/core/user/user.service";
import {AppModeService} from '@store/services/app-mode.service'
import {AppMode} from 'app/enums/AppModeEnum'
import {PublicationAccessService} from "../../../../modules/landing-publication/publication-access.service";
import {SurveyViewerService} from "../../../../modules/survey/survey-viewer/services/survey-viewer.service";

@Component({
    selector: 'dense-layout',
    templateUrl: './dense.component.html',
    styleUrls: ['./dense.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DenseLayoutComponent implements OnInit, OnDestroy {

  navigation$: Observable<Navigation>
  mediaChanges$: Observable<{
    matchingAliases: string[],
    matchingQueries: any,
    orientation: 'portrait' | 'landscape' | 'unknown',
    smallAndLandscape: boolean,
  }>

  smallAndLandscape$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  mainNavigationName = 'mainNavigation'
  appMode = AppMode
  isScreenSmall: boolean;
  navigationAppearance: 'default' | 'dense' = 'dense';
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _navigationService: NavigationService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _fuseNavigationService: FuseNavigationService,
    public appModeService: AppModeService,
    public userService: UserService,
    public publicationAccessService: PublicationAccessService,
    public surveyViewerService: SurveyViewerService,

  ) {
    // publicationAccessService.publication$.subscribe(publication => {
    //   console.log(publication)
    // })
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.navigation$ = this._navigationService.navigation$
    this.mediaChanges$ = this._fuseMediaWatcherService.onMediaChange$

    this.mediaChanges$.pipe().subscribe((data) => {
      this.smallAndLandscape$.next(data.smallAndLandscape);
    })


  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  isSmallScreenSize(event): boolean {
    const {matchingAliases} = event
    return !matchingAliases.includes('md')
  }

  /**
   * Toggle navigation
   */
  toggleNavigation(): void {
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(this.mainNavigationName)

    if (navigation) {
      navigation.toggle()
    }
  }

  /**
   * Toggle the navigation appearance
   */
  toggleNavigationAppearance(): void {
    this.navigationAppearance = (this.navigationAppearance === 'default' ? 'dense' : 'default');
  }

}
